import React from "react";

const AIVYChatInterface = () => {
  const questions = [
    {
      text: "언제 공부할 때 가장 집중이 잘 되나요?",
      answer: "새벽 일찍 조용할 때",
    },
    {
      text: "어떤 환경에서 공부하는 걸 좋아하나요?",
      answer: "완전히 조용한 곳",
    },
    {
      text: "스트레스 받을 때 어떻게 하나요?",
      answer: "혼자 조용히 정리하며 극복",
    },
    { text: "효과적인 암기 방법은?", answer: "소리내어 암기/노래" },
  ];

  const selectedIndex = 1; // 두 번째 질문 선택된 상태

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        padding: "30px",
        background: "linear-gradient(135deg, #f5f3ff 0%, #e8e5ff 100%)",
        borderRadius: "24px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      {/* 왼쪽 패널 */}
      <div
        style={{
          background: "rgba(255,255,255,0.9)",
          borderRadius: "16px",
          padding: "20px",
          width: "280px",
          minWidth: "250px",
          flex: "1 1 280px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            R
          </div>
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#1e293b" }}
          >
            사용자 입력 데이터
          </span>
        </div>

        {questions.map((q, i) => (
          <div
            key={i}
            style={{
              background:
                i === selectedIndex
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "#f8f9fa",
              color: i === selectedIndex ? "white" : "#334155",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "8px",
              fontSize: "13px",
              lineHeight: "1.5",
            }}
          >
            <div>{q.text}</div>
            <div style={{ fontSize: "11px", marginTop: "4px", opacity: 0.8 }}>
              → {q.answer}
            </div>
          </div>
        ))}
      </div>

      {/* 중앙 대화 영역 */}
      <div
        style={{
          flex: "2 1 300px",
          minWidth: "280px",
          background: "linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%)",
          borderRadius: "16px",
          padding: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
            }}
          >
            🤖
          </div>
          <span
            style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b" }}
          >
            데이터 마스킹
          </span>
        </div>

        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          <div style={{ color: "#64748b", marginBottom: "8px" }}>
            🔒 보안 처리 중...
          </div>
          <div style={{ marginBottom: "12px" }}>
            Q: {questions[selectedIndex].text}
          </div>
          <div style={{ color: "#94a3b8" }}>
            A: ███ ████ ████
            <br />
            ████ ██ ████
            <br />
            ███ ████
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginTop: "16px",
              paddingTop: "16px",
              borderTop: "1px solid #f1f5f9",
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            <div
              style={{
                width: "6px",
                height: "6px",
                background: "#10b981",
                borderRadius: "50%",
              }}
            ></div>
            ✓ 민감정보 마스킹 완료
          </div>
        </div>
      </div>

      {/* 오른쪽 MCP 패널 */}
      <div
        style={{
          background: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
          borderRadius: "16px",
          padding: "20px",
          width: "240px",
          minWidth: "240px",
          flex: "1 1 240px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            🔌
          </div>
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#1e293b" }}
          >
            MCP 처리
          </span>
        </div>

        <div
          style={{
            background: "white",
            borderRadius: "10px",
            padding: "16px",
            marginBottom: "12px",
          }}
        >
          <div
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#3b82f6",
              marginBottom: "8px",
            }}
          >
            📘 Model Context Protocol
          </div>
          <div
            style={{ fontSize: "12px", color: "#475569", lineHeight: "1.5" }}
          >
            📋 요청 분석 완료
            <br />
            • 학습 패턴 분석 요청
            <br />
            • 최적 집중 시간대 분류
            <br />• 성향 분석 + 컬러 매칭
          </div>
        </div>

        <div
          style={{
            background: "rgba(255,255,255,0.5)",
            border: "1px dashed rgba(59,130,246,0.3)",
            borderRadius: "10px",
            padding: "12px",
            textAlign: "center",
            fontSize: "13px",
            fontWeight: "500",
            color: "#1e293b",
          }}
        >
          → AIVY 에이전트 선택
        </div>
      </div>
    </div>
  );
};

export default AIVYChatInterface;
